import * as React from 'react';

const PetsAllowed = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
            transform="matrix(-1 0 0 1 21 1)"
        >
            <circle cx={10} cy={10} r={9.375} />
            <path d="M4.063 17.255C8.125 5 8.6 4.375 10.625 4.375v2.5l4.31 2.154c.423.212.69.645.69 1.119v.477a2.5 2.5 0 0 1-2.5 2.5h-1.25v6.062M11.874 16.249l-6.248-3.644" />
        </g>
    </svg>
);
export default PetsAllowed;
